import moment from 'moment';
import React, { Component } from 'react';
import { SizeMe } from 'react-sizeme';

/* Dynamic Dashboard */
import * as preference from '../../lib/components/Preference';
import { DynamicGridGenerator } from '../../lib/components/value/platform_value_grid';

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as modalActions } from '../../redux/ducks/modal'
import { actions as loadingActions } from '../../redux/ducks/loading'

/* Download */
import fileDownload from 'js-file-download';

/* Object Json */
import { isEmpty, isNone } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType, stringify } from 'iotera-base/json'
import { parseNavConf, buildCommandId, buildDownloadId } from '../../webservice/config';
import Result from 'iotera-base/result';

import Iframe from 'react-iframe'
import { SubViewHeaderDashboard, SubViewHeaderWithTenantName } from '../../lib/components/subHeader';
import { toDate } from '../../lib/components/formatter';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const EDIT_POSITION = 'EDIT_POSITION';
const DELETE_COMPONENT_DASHBOARD = 'DELETE_COMPONENT_DASHBOARD';
const WKEY = 'DASHBOARD';
let wSelector = null;
let wBoundActions = null

function saveToLS(key, value) {
  localStorage.setItem(key, stringify(value));
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    const navId = safeDeepGetWithType(this, ['props', 'id'], '');
    this.state = {
      dummy: {},
      event: null,
      isFromChart: true,
      loading: true,
      listDash: [],
      first: false,
      navId
    }
    this.resize = this.resize.bind(this);
    this.handleControl = this.handleControl.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleEditDashboard = this.handleEditDashboard.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDropdown = this.handleDropdown.bind(this);
    this.handleControlCustom = this.handleControlCustom.bind(this);
    this.handleDropdownCustom = this.handleDropdownCustom.bind(this);
    this.handlePeriod = this.handlePeriod.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleMarker = this.handleMarker.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleChangeLayout = this.handleChangeLayout.bind(this);
    this.saveLayout = this.saveLayout.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleSelectFirstItem = this.handleSelectFirstItem.bind(this);
    this.handleSelectedDeviceId = this.handleSelectedDeviceId.bind(this);
    this.wcallback = this.wcallback.bind(this);
  }

  wcallback(_this) {
    const finish = function (id, result) {
      const _props = _this.props;
      const _state = _this.state
      let type = safeDeepGetWithType(_state, ['event'], '');
      if (type === 'control') {
        if (result.code === Result.HTTP.OK) {
          const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
          if (responseResult === Result.SUCCESS) {
            _props.showSingleNotification({ message: 'Kirim perintah berhasil', level: 'success' });
          } else {
            _props.showSingleNotification({ message: 'Kirim perintah gagal', level: 'error' });
          }
        } else if (result.code === Result.HTTP.BAD_REQUEST) {
          const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
          if (responseResult === Result.NETWORK_FAILURE) {
            _props.showSingleNotification({ message: 'Kirim perintah gagal (perangkat sedang offline)', level: 'error' });
          } else if (responseResult === Result.BUSY) {
            _props.showSingleNotification({ message: 'Kirim perintah gagal (perangkat sibuk)', level: 'error' });
          } else if (responseResult === Result.TIMEOUT) {
            _props.showSingleNotification({ message: 'Kirim perintah gagal (timeout)', level: 'error' });
          } else {
            _props.showSingleNotification({ message: 'Kirim perintah gagal', level: 'error' });
          }
        } else {
          _props.showSingleNotification({ message: 'Kirim perintah gagal', level: 'error' });
        }
      } else if (type === 'download') {
        if (result.code === Result.HTTP.OK) {
          let csvDataString = safeDeepGetWithType(result, ['body'], '');
          _props.showSingleNotification({ message: 'Download sedang dilakukan', level: 'info' });
          let now = moment().unix() * 1000;
          let nowString = toDate(now, 'YYYYMMDD_HHmmss')
          let idChart = id.substring(9, id.length)
          const isFromChart = safeDeepGetWithType(_state, ['isFromChart'], true);
          if (isFromChart) {
            return fileDownload(csvDataString, `Chart_${idChart}_${nowString}.csv`);
          }
          return fileDownload(csvDataString, `Data_${idChart}_${nowString}.csv`);
        }
      }
    }
    return ({
      finished: finish
    })
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    const wsKey = WKEY + '_' + navId;
    wBoundActions = buildWBoundActions(wsKey);
    wSelector = buildWSelector(wsKey);
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    // Get dashboard
    _props.wInitRequestCall(
      {
        wparam: {
          ...domainIsTenant,
          path: '/service/web/application/nav/dashboard/' + navId,
        },
        wcallback: {
          started: function (id) {
            _props.showLoading();
          },
          finished: function (id, result) {
            _props.hideLoading();
            if (result.code === Result.HTTP.OK) {
              const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
              if (responseResult === Result.SUCCESS) {
                _this.setState({
                  loading: false
                })
                const dashType = safeDeepGetWithType(result, ['body', 'conf_dashboard', 'type'], preference.DASHBOARD_BASIC);
                if (dashType === preference.DASHBOARD_EMBEDDED) {
                  return;
                }
                const navDashboard = safeDeepGetWithType(result, ['body', 'conf_dashboard', 'dashboard'], {});
                let path = safeDeepGetWithType(result, ['body', 'path'], '');
                let isEmbedded = false;
                let deepDashboard = navDashboard[Object.keys(navDashboard)[0]];
                const cat = safeDeepGetWithType(deepDashboard, ['cat'], '');
                if (cat === preference.TYPE_EMBEDDED) {
                  isEmbedded = true;
                }
                if (!isEmbedded) {
                  const parseResult = parseNavConf(domainIsTenant, navId, navDashboard, _state.listDash);
                  if (!isNone(parseResult)) {
                    let singleConf = parseResult['refresh_data'];
                    let newSingleConf = {
                      [EDIT_POSITION]: {
                        wparam: {
                          ...domainIsTenant,
                          method: "POST",
                          path: "/service/web/application/nav/edit"
                        },
                        wcallback: {
                          started: function (id) {
                            _this.setState({
                              loading: true
                            })
                          },
                          finished: function (id, result) {
                            if (result.code === Result.HTTP.OK) {
                              const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                              if (responseResult === Result.SUCCESS) {
                                _this.setState({
                                  loading: false
                                })
                                // Magic to refresh routes
                                _props.history.push('..' + S + '_dashboard_list_')
                                _props.history.push('.' + S + '_dashboard_conf_' + S + _this.state.path)
                                _props.showSingleNotification({ message: 'Simpan posisi dashboard sukses', level: 'success' });
                                return;
                              }
                            }
                            _this.setState({
                              loading: false
                            })
                            _props.showSingleNotification({ message: 'Simpan posisi dashboard gagal', position: 'tr', level: 'error' });
                          }
                        }
                      },
                      [DELETE_COMPONENT_DASHBOARD]: {
                        wparam: {
                          ...domainIsTenant,
                          method: "POST",
                          path: "/service/web/application/nav/remove/dashboard"
                        },
                        wcallback: {
                          started: function (id) {
                            _this.setState({
                              loading: true
                            })
                          },
                          finished: function (id, result) {
                            if (result.code === Result.HTTP.OK) {
                              const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                              if (responseResult === Result.SUCCESS) {
                                _this.setState({
                                  loading: false
                                })
                                // Magic to refresh routes
                                _props.history.push('..' + S + '_dashboard_list_')
                                _props.history.push('.' + S + '_dashboard_conf_' + S + _this.state.path)
                                _props.showSingleNotification({ message: 'Hapus component dashboard berhasil', level: 'success' });
                                return;
                              }
                            }
                            _this.setState({
                              loading: false
                            })
                            _props.showSingleNotification({
                              message: 'Hapus component dashboard gagal',
                              position: 'tr', level: 'error'
                            });
                          }
                        }
                      }
                    }
                    let singleConfFinal = { ...singleConf, ...newSingleConf }
                    _props.wSetConfig({
                      single_config: singleConfFinal
                    });
                    _this.setState({ first: true, path })
                  }
                }
              } else {
                _this.setState({
                  loading: false
                })
              }
            } else {
              _this.setState({
                loading: false
              })
            }
          }
        }
      }
    );
  }

  componentWillUnmount() {
    const _props = this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    const wsKey = WKEY + '_' + navId;
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: wsKey });
  }

  handleEditDashboard() {
    const _props = this.props
    const navId = safeDeepGetWithType(_props, ['id'], '');
    let path = safeDeepGetWithType(_props, ['path'], '');
    if (isNone(navId) || isEmpty(navId) || isNone(path) || isEmpty(path)) {
      return;
    }
    _props.history.push('..' + S + '_dashboard_edit_' + S + navId)
  }

  handleEdit(dashboardComponentId, auto = null) {
    const _props = this.props
    if (auto === null) {
      auto = true
    }
    const navId = safeDeepGetWithType(_props, ['id'], '');
    let path = safeDeepGetWithType(_props, ['path'], '');
    if (isNone(navId) || isEmpty(navId) || isNone(dashboardComponentId) || isNone(path) || isEmpty(path)) {
      return;
    }
    if (auto) {
      _props.history.push('.' + S + path + S + 'edit' + S + dashboardComponentId)
    } else {
      _props.history.push('.' + S + path + S + 'manual_edit' + S + dashboardComponentId)
    }
  }

  handleDelete(dashboardComponentId) {
    const _props = this.props
    const id = safeDeepGetWithType(_props, ['id'], '');
    let path = safeDeepGetWithType(_props, ['path'], '');
    if (isNone(id) || isEmpty(id) || isNone(dashboardComponentId) || isEmpty(path) || isNone(path)) {
      return;
    }
    _props.wSingleRequestCall({
      id: DELETE_COMPONENT_DASHBOARD,
      body: {
        id,
        dashboard_id: dashboardComponentId
      }
    });
  }

  handleDropdown(dashboardId, param) {
    const _props = this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let devId = safeDeepGetWithType(param, ['deviceId'], '');
    _props.wSetEnv({
      type: "params",
      env: dashboardId,
      value: { 'device_id': devId }
    });
    _props.wSingleRequestCall({
      id: dashboardId
    });
    _props.wSetEnv({
      type: "body",
      env: buildCommandId(dashboardId),
      value: { 'device_id': devId }
    });
  }

  handleControl(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let value = safeDeepGet(param, ['value']);
    const body = {};
    if (value !== null) {
      body.value = value;
    }
    _this.setState({
      event: 'control'
    })
    _props.wSingleRequestCall({
      id: buildCommandId(dashboardId),
      body
    });
  }

  handleDropdownCustom(dashboardId, params) {
    const _props = this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let devId = safeDeepGetWithType(params, ['deviceId'], '');
    let sensor = safeDeepGetWithType(params, ['sensor'], '');
    let config = safeDeepGetWithType(params, ['config'], '');
    let param = safeDeepGetWithType(params, ['param'], '');
    _props.wSetEnv({
      type: "params",
      env: dashboardId,
      value: { 'device_id': devId, sensor, config, param }
    });
    _props.wSingleRequestCall({
      id: dashboardId
    });

    _props.wSetEnv({
      type: "body",
      env: buildCommandId(dashboardId),
      value: { 'device_id': devId, sensor, config, param }
    });
  }

  handleControlCustom(dashboardId, param) {
    const _this = this
    const _props = this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let value = safeDeepGet(param, ['value']);
    const body = {};
    if (value !== null) {
      body.value = value;
    }
    _this.setState({
      event: 'control'
    })
    _props.wSingleRequestCall({
      id: buildCommandId(dashboardId),
      body
    });
  }

  handlePeriod(dashboardId, param) {
    const _props = this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let value = safeDeepGet(param, ['value']);
    const body = {};
    if (value !== null) {
      body.value = value;
    }
    _props.wSetEnv({
      type: "params",
      env: dashboardId,
      value: { 'period': value }
    });
    _props.wSingleRequestCall({
      id: dashboardId
    });
  }

  handleDownload(dashboardId, param, isFromChart) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let value = safeDeepGet(param, ['value']);
    _this.setState({
      event: 'download',
      isFromChart: isFromChart,
    })
    _props.wSingleRequestCall({
      id: buildDownloadId(dashboardId),
      body: {},
      param: {
        period: value
      }
    });
  }

  handleSelectedDeviceId(body, dashboardsAffected) {
    const _props = this.props
    for (let i = 0; i < dashboardsAffected.length; i++) {
      _props.wSetEnv({
        type: "params",
        env: dashboardsAffected[i],
        obj: body
      });
      _props.wSingleRequestCall({
        id: dashboardsAffected[i]
      });
    }
  }

  handleMarker(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGetWithType(_props, ['id'], '');
    if (isEmpty(navId) || isNone(dashboardId)) {
      return;
    }
    let device_id = safeDeepGetWithType(param, ['value'], '');
    let dashboardsAffected = safeDeepGetWithType(_props, ['data', dashboardId + '_rpayload', 'affect'], []);
    const body = {
      device_id
    };
    _this.handleSelectedDeviceId(body, dashboardsAffected);
  }

  handleSelectFirstItem(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId) || isNone(dashboardId)) {
      return;
    }
    let devices = safeDeepGetWithType(param, ['devices'], []);
    if (devices.length < 1) {
      return;
    }
    let device_id = safeDeepGetWithType(devices, [0, 'dev_id'], '');
    let dashboardsAffected = safeDeepGetWithType(_props, ['data', dashboardId + '_rpayload', 'affect'], []);
    const body = {
      device_id
    };
    _this.handleSelectedDeviceId(body, dashboardsAffected);
  }

  resize(event) {
    this.setState({ event });
  }

  handleAdd(auto = null) {
    const _props = this.props
    if (auto === null) {
      auto = true;
    }
    const navId = safeDeepGetWithType(_props, ['id'], '');
    let path = safeDeepGetWithType(_props, ['path'], '');
    if (isNone(navId) || isEmpty(navId) || isNone(path) || isEmpty(path)) {
      return;
    }
    if (auto) {
      _props.history.push('.' + S + path + S + 'add')
    } else {
      _props.history.push('.' + S + path + S + 'manual_add')
    }

  }

  handleRefresh() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const navId = safeDeepGetWithType(_props, ['id'], '');
    if (isNone(navId) || isEmpty(navId)) {
      return;
    }
    const listDash = safeDeepGetWithType(_state, ['listDash'], []);
    if (isNone(listDash) || isEmpty(listDash)) {
      return;
    }
    for (let i = 0; i < listDash.length; i++) {
      _props.wSingleRequestCall({
        id: listDash[i]
      });
    }
    const first = safeDeepGetWithType(_state, ['first'], false);
    if (first)
      _this.setState({ first: false })
  }

  handleChangeLayout(layouts) {
    this.setState({ layouts })
  }

  saveLayout() {
    const _props = this.props
    const _state = this.state
    const navId = safeDeepGetWithType(_props, ['id'], '');
    let layouts = safeDeepGetWithType(_state, ['layouts'], {});
    const conf_dashboard = safeDeepGetWithType(_props, ['conf_dashboard'], {});
    const curr_dashboard = safeDeepGetWithType(conf_dashboard, ['dashboard'], {});
    let breakpoint = 'xxs';
    let width = window.innerWidth
    if (width >= 1200) {
      breakpoint = 'lg'
    } else if (width >= 996) {
      breakpoint = 'md'
    } else if (width >= 768) {
      breakpoint = 'sm'
    } else if (width >= 480) {
      breakpoint = 'xs'
    }
    let dashChanged = {};
    if (breakpoint === 'md' || breakpoint === 'lg') {
      let layoutToSaveArr = safeDeepGetWithType(layouts, [breakpoint], []);
      let layoutToSaveObj = {}
      for (let z = 0; z < layoutToSaveArr.length; z++) {
        let key = safeDeepGetWithType(layoutToSaveArr, [z, 'i'], '');
        let x = safeDeepGetWithType(layoutToSaveArr, [z, 'x'], 0);
        let y = safeDeepGetWithType(layoutToSaveArr, [z, 'y'], 0);
        let w = safeDeepGetWithType(layoutToSaveArr, [z, 'w'], 1);
        let h = safeDeepGetWithType(layoutToSaveArr, [z, 'h'], 1);
        if (h >= 2) {
          h /= 2
        }
        layoutToSaveObj[key] = {
          x, y, w, h
        }
        const currSomeA = curr_dashboard[key]
        const currSomeB = layoutToSaveObj[key]
        const mix = { ...currSomeA, ...currSomeB }
        dashChanged[key] = mix;
      }
      conf_dashboard.dashboard = dashChanged;
      const id = safeDeepGet(_props, ['id']);
      saveToLS(navId, layouts);
      _props.wSingleRequestCall({
        id: EDIT_POSITION,
        body: {
          id,
          conf_dashboard
        }
      });
    }
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { first } = _state
    if (first) {
      _this.handleRefresh();
    }
    const config = safeDeepGetWithType(_props, ['config'], {});
    const conf_dashboard = safeDeepGetWithType(_props, ['conf_dashboard'], {});
    const data = safeDeepGetWithType(_props, ['data'], {});
    window.onresize = _this.resize;
    const heights = window.screen.height * 90 / 100 - 176;
    const label = safeDeepGetWithType(_props, ['label'], '');
    const path = safeDeepGetWithType(_props, ['path'], '');
    let url = '';
    let isEmbedded = false;
    if (!isEmpty(conf_dashboard)) {
      const type = safeDeepGetWithType(conf_dashboard, ['type'], preference.DASHBOARD_BASIC);
      if (type === preference.DASHBOARD_EMBEDDED) {
        url = safeDeepGetWithType(conf_dashboard, ['custom_url'], 'google.com');
        isEmbedded = true;
      }
    }
    const _var = safeDeepGetWithType(conf_dashboard, ['var'], {});
    const dash_view = safeDeepGetWithType(conf_dashboard, ['view'], {});
    let navId = safeDeepGetWithType(_state, ['navId'], '')
    const wsKey = WKEY + '_' + navId;
    let loading = safeDeepGetWithType(_state, ['loading'], true);
    if (loading) {
      return (<div />)
    }
    if (isEmbedded) {
      // for Iframe
      return (
        <SizeMe>{({ size }) =>
          <div className="view" style={{ minWidth: '100%' }}>
            <SubViewHeaderWithTenantName title={'Edit ' + label} path={path} hasRefresh={false} />
            <div className="view-content-dashboard" style={{ minWidth: '100%', padding: 0 }}>
              <Iframe url={url}
                width="100%"
                height={heights}
                id="myId"
              />
            </div>
          </div>
        }
        </SizeMe>
      );
    } else {
      return (
        <SizeMe>{({ size }) =>
          <div className="view" >
            <SubViewHeaderDashboard {..._props} title={'Edit ' + label} path={path} hasRefresh={true}
              handleRefresh={_this.handleRefresh} handleAdd={_this.handleAdd} handleEdit={_this.handleEditDashboard}
              saveLayout={_this.saveLayout} />
            <DynamicGridGenerator
              config={config}
              data={data}
              _var={_var}
              navId={navId}
              dash_view={dash_view}
              wsKey={wsKey}
              handleEdit={_this.handleEdit}
              handleDelete={_this.handleDelete}
              handleDropdown={_this.handleDropdown}
              handleControl={_this.handleControl}
              handleDropdownCustom={_this.handleDropdownCustom}
              handleControlCustom={_this.handleControlCustom}
              handlePeriod={_this.handlePeriod}
              handleDownload={_this.handleDownload}
              handleMarker={_this.handleMarker}
              handleChangeLayout={_this.handleChangeLayout}
              handleSelectFirstItem={_this.handleSelectFirstItem}
              contentWidth={size.width}
              staticGrid={false}
              style={{ margin: 5 }} />
          </div>
        }
        </SizeMe>
      );
    }
  }
}

const mapStateToProps = function (state, ownProps) {
  const navId = safeDeepGet(ownProps, ['id']);
  if (isNone(navId)) {
    return {}
  }
  const wsKey = WKEY + '_' + navId;
  wSelector = buildWSelector(wsKey);
  wBoundActions = buildWBoundActions(wsKey);
  return {
    conf_dashboard: wSelector.getSoleInitMappedRPayload(state, 'conf_dashboard'),
    config: wSelector.getSoleInitMappedRPayload(state, 'conf_dashboard', 'dashboard'),
    label: wSelector.getSoleInitMappedRPayload(state, 'label'),
    path: wSelector.getSoleInitMappedRPayload(state, 'path'),
    data: wSelector.getMappedState(state)
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(modalActions, dispatch),
    ...bindActionCreators(loadingActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));